import { useT } from '@/i18n/LanguageContext';

export function EmptyState({ title, hint }: { title: string; hint?: string }): JSX.Element {
  return (
    <div className="empty-state">
      <div>{title}</div>
      {hint && <div style={{ fontSize: 12, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export function LoadingState({ label }: { label?: string }): JSX.Element {
  const t = useT();
  return (
    <div className="empty-state" role="status" aria-live="polite">
      {label ?? t('common.loading')}
    </div>
  );
}
